import { useLanguage } from '@/i18n/language-context';

const en = {
  choose: 'Choose your church',
  search: 'Search by name',
  searchHint: 'Search all churches, or choose a conference below.',
  backConferences: 'Back to conferences',
  noConferences: 'No conferences are available.',
  noChurches: 'No churches are available in this conference.',
  myChurch: 'My church',
  optionalChurch: 'My church · optional',
  chooseAction: 'Choose',
  change: 'Change',
  noSelection: 'No selection',
  close: 'Close',
  loading: 'Loading churches…',
  loadFailed: 'We could not load the churches. Please try again.',
  saveFailed: 'We could not save your church. Please try again.',
  retry: 'Try again',
  noResults: 'No churches found. Try another name.',
  narrowSearch: 'Keep typing to narrow the results.',
  saving: 'Saving your church…',
  quickGiving: 'Give quickly',
  tithe: 'Tithe',
  localBudget: 'Local church giving',
  recommended: 'Recommended projects',
  unionProjects: 'Union projects',
  conferenceProjects: 'Conference projects',
  seeAll: 'View all',
  contentFailed: 'We could not load these giving options. Please try again.',
  loadingProjects: 'Loading giving options…',
  chooseForGiving: 'Choose your church to see its quick giving options.',
};
type ChurchCopy = { [Key in keyof typeof en]: string };
const ro: ChurchCopy = {
  choose: 'Alege-ți biserica',
  search: 'Caută după nume',
  searchHint: 'Caută în toate bisericile sau alege o Conferință din listă.',
  backConferences: 'Înapoi la Conferințe',
  noConferences: 'Nu există Conferințe disponibile.',
  noChurches: 'Nu există biserici disponibile în această Conferință.',
  myChurch: 'Biserica mea',
  optionalChurch: 'Biserica mea · opțional',
  chooseAction: 'Alege',
  change: 'Schimbă',
  noSelection: 'Fără selecție',
  close: 'Închide',
  loading: 'Se încarcă bisericile…',
  loadFailed: 'Nu am putut încărca bisericile. Încearcă din nou.',
  saveFailed: 'Nu am putut salva biserica. Încearcă din nou.',
  retry: 'Încearcă din nou',
  noResults: 'Nu am găsit biserici. Încearcă alt nume.',
  narrowSearch: 'Continuă să scrii pentru a restrânge rezultatele.',
  saving: 'Se salvează biserica…',
  quickGiving: 'Dăruiește rapid',
  tithe: 'Zecime',
  localBudget: 'Buget local',
  recommended: 'Proiecte recomandate',
  unionProjects: 'Proiectele Uniunii',
  conferenceProjects: 'Proiectele Conferinței',
  seeAll: 'Vezi toate',
  contentFailed: 'Nu am putut încărca opțiunile de dăruire. Încearcă din nou.',
  loadingProjects: 'Se încarcă opțiunile de dăruire…',
  chooseForGiving: 'Alege-ți biserica pentru a vedea opțiunile de dăruire rapidă.',
};
const hu: ChurchCopy = {
  choose: 'Válaszd ki a gyülekezetedet',
  search: 'Keresés név szerint',
  searchHint: 'Keress az összes gyülekezet között, vagy válassz egyházterületet.',
  backConferences: 'Vissza az egyházterületekhez',
  noConferences: 'Nincs elérhető egyházterület.',
  noChurches: 'Ebben az egyházterületben nincs elérhető gyülekezet.',
  myChurch: 'A gyülekezetem',
  optionalChurch: 'A gyülekezetem · nem kötelező',
  chooseAction: 'Válassz',
  change: 'Módosítás',
  noSelection: 'Nincs kiválasztva',
  close: 'Bezárás',
  loading: 'Gyülekezetek betöltése…',
  loadFailed: 'Nem sikerült betölteni a gyülekezeteket. Próbáld újra.',
  saveFailed: 'Nem sikerült menteni a gyülekezetet. Próbáld újra.',
  retry: 'Újrapróbálkozás',
  noResults: 'Nincs találat. Próbálj másik nevet.',
  narrowSearch: 'Folytasd a gépelést a találatok szűkítéséhez.',
  saving: 'Gyülekezet mentése…',
  quickGiving: 'Gyors adományozás',
  tithe: 'Tized',
  localBudget: 'Helyi gyülekezeti adomány',
  recommended: 'Ajánlott projektek',
  unionProjects: 'Az unió projektjei',
  conferenceProjects: 'Az egyházterület projektjei',
  seeAll: 'Összes megtekintése',
  contentFailed: 'Nem sikerült betölteni az adományozási lehetőségeket. Próbáld újra.',
  loadingProjects: 'Adományozási lehetőségek betöltése…',
  chooseForGiving: 'Válassz gyülekezetet a gyors adományozási lehetőségekhez.',
};
export function useChurchCopy(): ChurchCopy {
  const { locale } = useLanguage();
  return { ro, en, hu }[locale];
}
